import { css } from '@emotion/react';
import { Spinner, VisuallyHidden } from 'folio-common-components';
import * as React from 'react';

export type StatusIndicatorState = 'hidden' | 'inProgress' | 'done';

export const StatusIndicator: React.FC<{ state: StatusIndicatorState }> = ({
  state,
  ...rest
}) => {
  return (
    <>
      <VisuallyHidden>
        {state === 'done' ? 'Ferdig' : state === 'inProgress' ? 'Laster' : null}
      </VisuallyHidden>
      <div
        aria-hidden="true"
        css={css`
          display: inline-block;
          transition: opacity 0.2s;
          opacity: ${state === 'inProgress' ? 1 : 0};
        `}
        {...rest}
      >
        <Spinner strokeWidth={2} size={16} />
      </div>
    </>
  );
};
